import React from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import { 
  showObjProperties 
} from '../../helpers/actions/Action'
import store from "../../helpers/store/Store";

class Properties extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      show: false,
      activeDrags: 0,
      isResizing: false,
      width: null,
      height: null,
      minWidth: 320,
      minHeight: 110,
      initialX: null,
      initialY: null,
      oldX: null,
      oldY: null,
      deltaPosition: {
        x: 0, y: 0
      },
      controlledPosition: {
        x: -400, y: 200
      },
      properties: []
    };
  }

  hide = (id) => {
    store.dispatch(showObjProperties({id: id, show: false})) 
  }

  mapDynamic = (properties) => (
    <div id='dynaPropertiesAccordion' className='accordion'>
    <div className='card'>
      <div className='card-header' id="headingDyna">
                                        <a data-toggle='collapse' data-target={`#collapseBodyDynaProp`} aria-expanded='false' aria-controls={`collapseBodyDynaProp}`} href='/'>Dynamic Properties </a>
                                        </div>
                                        <div id={`collapseBodyDynaProp`} className='collapse collapsed' aria-labelledby={`headingDynaProp`} data-parent='#dynaPropertiesAccordion'>
                                          <div className='card-body'>
                                            <table className='table table-sm table-border'>
                                    <tbody>
                                   { properties.map((dynaProp, index) => {
                                                      return (
                                                          <tr key={index}>
                                                            <th> { dynaProp.propName } </th>
                                                            <td> { dynaProp.propValue } </td>
                                                          </tr>
                                                       

                                                        


                                                      );
                                                    })}
                                    </tbody>
</table>
</div>
</div>
</div>
</div>
       
  )

  mapProperties = (properties) => (
    <div id='propertiesAccordion' className='accordion'>
      {(properties.data.length > 0) ?  properties.data.map((el, y) => (
        (el.data.length > 0) ? (
        <div className='card' key={properties.id}>
          <div className='card-header' id={`heading${y}-${properties.id}`}>
            <a data-toggle='collapse' data-target={`#collapseBody${y}-${properties.id}`} aria-expanded='false' aria-controls={`collapseBody${y}-${properties.id}`} href='/'> { el.category } </a>
          </div>
          <div id={`collapseBody${y}-${properties.id}`} className='collapse collapsed' aria-labelledby={`heading${y}-${properties.id}`} data-parent='#propertiesAccordion'>
            <div className='card-body'>
              <table className='table table-sm table-border'>
                {el.data.map((group, i) => (
                  this.mapGroups(group, i)
                ))}
              </table>
            </div>
          </div>
          </div>)
        : (
        (el.category === 'Issues' + el.data.displayValue) 
        ? (
          <div key={el.data.id}>
            <table className='table table-sm table-border'>
              <tbody>
                <tr key={1 + '-' + el.data.id + '-title-' + y}>
                  <th>Title</th>
                  <td>{el.data.displayName}</td>
                </tr>
                <tr key={2 + '-' + el.data.id + '-title-' + y}>
                  <th>Status</th>
                  <td>{el.data.status}</td>
                </tr>
                <tr key={3 + '-' + el.data.id + '-url-' +  y}>
                  <th>URL</th>
                  <td><a href={el.data.displayValue} rel="noopener noreferrer" target="_blank">Bim 360 issue</a></td>
                </tr>
              </tbody>
            </table>
          </div>)
        : (
          <div>
          <table className='table table-sm table-border'>
            <tbody key={1 + '-' + el.data.displayName}>
              <tr key={2 + '-' + el.data.displayName}>
                <th>URL</th>
                <td><a href={el.data.displayValue} rel="noopener noreferrer" target="_blank">{el.data.displayName}</a></td>
              </tr>
            </tbody>
          </table>
        </div>))
        ))
        :  <p>There is no data associated with this object.</p>
      }
    </div>
  )

  mapGroups = (group, i) => (
    <tbody key={i}>
      {group.data.map((item, index) => (
        <tr key={index}>
          <th> { item.displayName } </th>
          <td> { item.displayValue } { item.units }</td>
        </tr>
      ))}
    </tbody>
  )

  onStart = () => {
    this.setState({ activeDrags: this.state.activeDrags + 1 });
  }

  onStop = () => {
    this.setState({ activeDrags: this.state.activeDrags - 1 });
  }

  onControlledDrag = (e, position) => {
    const {x, y} = position;
    this.setState({controlledPosition: {x, y}});
  }

  mouseDown = (e) => {
    let width = document.querySelector('.modal-content').clientWidth
    let height = document.querySelector('.modal-content').clientHeight
    this.setState({
      isResizing: true,
      oldX: e.pageX,
      oldY: e.pageY,
      initialX: e.pageX,
      initialY: e.pageY,
      width: width,
      height: height
    })
  }

  mouseUp = (e) => {
    if (this.state.isResizing) {
      this.setState({
        isResizing: false
      })
    }
  }

  mouseMove = (e) => {
    if (this.state.isResizing) {
      let newX = this.state.width + (e.pageX - this.state.oldX)
      let newY = this.state.height + (e.pageY - this.state.oldY)

      let oldX = e.pageX < this.state.minWidth ? this.state.minWidth : e.pageX
      let oldY = e.pageY < this.state.minHeight ? this.state.minHeight : e.pageY

      oldX = oldX < this.state.initialX ? this.state.initialX : oldX
      oldY = oldY < this.state.initialY ? this.state.initialY : oldY

      newX = newX < this.state.minWidth ? this.state.minWidth : newX
      newY = newY < this.state.minHeight ? this.state.minHeight : newY
      
      this.setState({
        height: newY,
        width: newX,
        oldX: oldX,
        oldY: oldY
      })
    }
  }

  static getDerivedStateFromProps(nextProps, prevState){
      let sameID = nextProps.properties !== null ? nextProps.id === nextProps.properties.id : false;
      let sameIDShow = nextProps.show !== {} ? nextProps.id === nextProps.show.id : false;
      if (sameID && sameIDShow) {
        return {
          properties: nextProps.properties,
          show: nextProps.show.show
        }
      } else if (sameID) {
        return {
          properties: nextProps.properties 
        }
      } else if (sameIDShow) {
        return {
          show: nextProps.show.show
        }
      }
   else return null;
 }
 

  componentDidMount() {
    document.addEventListener('mousemove', e => this.mouseMove(e));
    document.addEventListener('mouseup', e => this.mouseUp(e));
  }

  render() {
    const dragHandlers = {onStart: this.onStart, onStop: this.onStop}
    const { width, height, initialX } = this.state
    const sizeStyle = {
      style: {
        width: initialX !== null ? width + 'px' : 'none',
        height: initialX !== null ? height + 'px' : 'none' 
      }
    }
    const sizeBodyStyle = {
      style: {
        height: initialX !== null ? (height - 71) + 'px' : 'none'
      }
    }
    if (this.state.show) {
      return (
          <Draggable
            handle=".modal-header"
            {...dragHandlers} 
            onDrag={this.onControlledDrag}>
              <div className={`modal modal-resize-draggable modal-left fade ${!this.state.show ? "" : "show"}`}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content" {...sizeStyle}>
                    <div className="modal-header">
                      <button type="button" className="close" data-dismiss="modal" data-keyboard="true" onClick={((e) => this.hide(this.state.properties.id))}></button>
                      <h4 className="modal-title" id="rightResizeDraggableModalLabel">
                        { this.state.properties.issue === true ? (<span>Issue</span>) : (<span>Properties</span>)}
                      </h4>
                    </div>
                    <div className="modal-body">
                      <div className="modal-body-content" {...sizeBodyStyle}>
                        { this.mapProperties(this.state.properties) }


                        {
                                          this.props.elemWithProperties.filter(o=>o.tag == this.props.selectedTag && o.locked).map((elem, elemIndex) => {
                                              {
                                              return this.props.dynaPropValues.filter(x=>elem.tag === x.tag && elemIndex == 0).map((dynaPropValue, index) => {
                                                if (index == 0) {
                                                  return (
                                                    this.mapDynamic(dynaPropValue.propValueList)
                                                  );
                                                }
                                              });
                                              }


                                          })
                        }

                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn-resize-modal" onMouseDown={(e) => this.mouseDown(e)}></button>
                    </div>
                  </div>
                </div>
              </div>
          </Draggable>
          )
    } else {
      return null
    }
  }
}

const mapStateToProps = (state) => ({
  properties: state.getPropertiesReducer.data,
  show: state.getStateObjPropertiesReducer.data,
  elemWithProperties: state.metaPropReducer.elementWithProperties,
  selectedTag: state.metaPropReducer.selectedTag,
  dynaPropValues: state.metaPropReducer.dynaPropValues,
})

const List = connect(mapStateToProps)(Properties);

export default List;